import type { AssessmentQuestion } from '@ts-assessment/interfaces'

import imgQuestion1 from '@images/assessment/questions/math/grade-k5/question-1.png'
import imgQuestion2 from '@images/assessment/questions/math/grade-k5/question-2.png'
import imgQuestion8 from '@images/assessment/questions/math/grade-k5/question-8.png'
import imgQuestion9 from '@images/assessment/questions/math/grade-k5/question-9.png'
import imgQuestion10 from '@images/assessment/questions/math/grade-k5/question-10.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k5_1',
    title: 'Write the missing number In the expanded form of 867421, write the missing number with its place value.',
    topic: 'Place Value',
    image: imgQuestion1,
    answers: [
      {
        name: 'grade_k5_1_a',
        text: '7000',
        correct: true,
      },
      {
        name: 'grade_k5_1_b',
        text: '70000',
      },
      {
        name: 'grade_k5_1_c',
        text: '700',
      },
      {
        name: 'grade_k5_1_d',
        text: '70',
      },
    ],
  },
  {
    name: 'grade_k5_2',
    title: 'Round off the number 26.198 to the nearest hundredth.',
    topic: 'Rounding Off',
    image: imgQuestion2,
    answers: [
      {
        name: 'grade_k5_2_a',
        text: '26.300',
      },
      {
        name: 'grade_k5_2_b',
        text: '26.350',
      },
      {
        name: 'grade_k5_2_c',
        text: '26.100',
      },
      {
        name: 'grade_k5_2_d',
        text: '26.200',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_3',
    title: '120 ml juice is needed to fill 6 disposable glasses. How much juice is needed to fill 2 1/2 glasses?',
    topic: 'Multi-digit Whole Number Operation',
    answers: [
      {
        name: 'grade_k5_3_a',
        text: '15 ml',
      },
      {
        name: 'grade_k5_3_b',
        text: '30 ml',
      },
      {
        name: 'grade_k5_3_c',
        text: '40 ml',
      },
      {
        name: 'grade_k5_3_d',
        text: '50 ml',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_4',
    title: 'If one yard of the garden net costs $42.5, how much will the 7.5 yards of net cost?',
    topic: 'Multi-digit Decimal Fraction Operation',
    answers: [
      {
        name: 'grade_k5_4_a',
        text: '$318.75',
        correct: true,
      },
      {
        name: 'grade_k5_4_b',
        text: '$315',
      },
      {
        name: 'grade_k5_4_c',
        text: '$350.25',
      },
      {
        name: 'grade_k5_4_d',
        text: '$450.50',
      },
    ],
  },
  {
    name: 'grade_k5_5',
    title: 'Elie is 3 times older than Nick. Riz is 7 years older than Elie. If Nick’s age is x years, how old is Riz?',
    topic: 'Fractional Operations',
    answers: [
      {
        name: 'grade_k5_5_a',
        text: '2x + 7',
      },
      {
        name: 'grade_k5_5_b',
        text: 'x + 7',
      },
      {
        name: 'grade_k5_5_c',
        text: '3x + 7',
        correct: true,
      },
      {
        name: 'grade_k5_5_d',
        text: '7 - 3x',
      },
    ],
  },
  {
    name: 'grade_k5_6',
    title: 'Tina paid $252 for her 9-hour music lesson. Calculate the payment for 3 ½ hours.',
    topic: 'Multiplication and Division of Fractions',
    answers: [
      {
        name: 'grade_k5_6_a',
        text: '$60',
      },
      {
        name: 'grade_k5_6_b',
        text: '$98',
        correct: true,
      },
      {
        name: 'grade_k5_6_c',
        text: '$100',
      },
      {
        name: 'grade_k5_6_d',
        text: '$78',
      },
    ],
  },
  {
    name: 'grade_k5_7',
    title: 'The area of a square-shaped ground is 49m². Find out the length of one side of the ground.',
    topic: 'Multiplication and Division with Area',
    answers: [
      {
        name: 'grade_k5_7_a',
        text: '7m',
        correct: true,
      },
      {
        name: 'grade_k5_7_b',
        text: '8m',
      },
      {
        name: 'grade_k5_7_c',
        text: '9m',
      },
      {
        name: 'grade_k5_7_d',
        text: '5m',
      },
    ],
  },
  {
    name: 'grade_k5_8',
    title: 'Calculate the volume of the rectangular prism shown below.',
    topic: 'Multiplication with Volume.',
    image: imgQuestion8,
    answers: [
      {
        name: 'grade_k5_8_a',
        text: '450 cubic meters',
      },
      {
        name: 'grade_k5_8_b',
        text: '270 cubic meters',
        correct: true,
      },
      {
        name: 'grade_k5_8_c',
        text: '150 cubic meters',
      },
      {
        name: 'grade_k5_8_d',
        text: '350 cubic meters',
      },
    ],
  },
  {
    name: 'grade_k5_9',
    title: 'Spot the coordinates for the fourth corner of the dotted rectangle in the grid.',
    topic: 'Problem Solving with Coordinated Plane',
    image: imgQuestion9,
    answers: [
      {
        name: 'grade_k5_9_a',
        text: '5, 7',
      },
      {
        name: 'grade_k5_9_b',
        text: '6, 7',
      },
      {
        name: 'grade_k5_9_c',
        text: '8, 7',
      },
      {
        name: 'grade_k5_9_d',
        text: '7, 7',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_10',
    title: 'The coordinates of A, B, and C are:',
    topic: 'Problem Solving with Coordinated Plane',
    image: imgQuestion10,
    answers: [
      {
        name: 'grade_k5_10_a',
        text: 'A= (-3, 4); B= (2, 4); C= (4, 1);',
        correct: true,
      },
      {
        name: 'grade_k5_10_b',
        text: 'A= (-3, 4); B= (-2, -4); C= (4, 1);',
      },
      {
        name: 'grade_k5_10_c',
        text: 'A= (-3, -4); B= (2, 4); C= (4, -1);',
      },
      {
        name: 'grade_k5_10_d',
        text: 'A= (3, 4); B= (-2, 4); C= (-4, 1);',
      },
    ],
  },
]
